import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import { PATH_AFTER_LOGIN } from "../config";
//
import {
  Page404,
  Login,
  Registration,
  ForgotPassword,
  OtpVerify,
  ChangePassword,
  Dashboard,
  Deposits,
  Commissions,
  Invitations,
  Withdraw,
  Profile,
  ThirdPartyAddress,
} from "./elements";
import GuestLayout from "src/layouts/Guest/GuestLayout";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: (
        <GuestGuard>
          <GuestLayout />
        </GuestGuard>
      ),
      children: [
        { element: <Navigate to={"/login"} replace />, index: true },
        { path: "login", element: <Login /> },
        { path: "registration", element: <Registration /> },
        { path: "forgot-password", element: <ForgotPassword /> },
        { path: "Otp-verify", element: <OtpVerify /> },
        { path: "change-password", element: <ChangePassword /> },
      ],
    },
    {
      path: "/dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "dashboard", element: <Dashboard /> },
        { path: "deposits", element: <Deposits /> },
        { path: "withdraw", element: <Withdraw /> },
        { path: "invitations", element: <Invitations /> },
        { path: "commissions", element: <Commissions /> },
        { path: "thirdPartyAddress", element: <ThirdPartyAddress /> },
        { path: "profile", element: <Profile /> },
        // {
        //   path: "user",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/user/four" replace />,
        //       index: true,
        //     },
        //     { path: "four", element: <PageFour /> },
        //     { path: "five", element: <PageFive /> },
        //     { path: "six", element: <PageSix /> },
        //   ],
        // },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
